<template>
    <div class="modal fade"  id="source_email_modal"  tabindex="-1"  role="dialog">
        <div class="modal-dialog mx-auto" role="document" style="min-width:80% !important;">
            <div class="modal-content"  style="overflow:hidden;">
                <div class="modal-header"  style="font-size:24px; background-color:whitesmoke;">
                    <span class="align-self-center modal-title">Source Email</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
        
                <div class="modal-body text-left">
                    <table  v-if="status=='loading'"  style='width:100%;'>
                        <tbody>
                            <tr>
                                <td>
                                    &nbsp;<br>
                                    <i class="fas fa-circle-notch fa-spin"></i>  Loading data...<br>
                                    &nbsp;
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table v-else >
                        <tbody>
                            <tr>
                                <td style='padding-left:5px; padding-right:20px;'><b>Subject:</b></td>
                                <td>{{ email.subject }}</td>
                            </tr>
                            <tr>
                                <td style='padding-left:5px; padding-right:20px;'><b>From:</b></td>
                                <td>{{ email.from }}</td>
                            </tr>
                            <tr>
                                <td style='padding-left:5px; padding-right:20px;'><b>To:</b></td>
                                <td>{{ email.to }}</td>
                            </tr>
                            <tr>
                                <td style='padding-left:5px; padding-right:20px;'><b>cc:</b></td>
                                <td>{{ email.cc }}</td>
                            </tr>
                            <tr>
                                <td style='padding-left:5px; padding-right:20px;'><b>Dated:</b></td>
                                <td>{{ email.date }}</td>        
                            </tr>
                            <tr>
                                <td style='padding-left:5px; padding-right:20px;'><b>Attachments:</b></td>
                                <td>{{ email.attachments }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table  v-if="status!='loading'"  style='width:100%; border-collapse:collapse; margin-top:5px;'>
                        <thead style="display: table-header-group;">
                            <tr style="page-break-inside:avoid; border-bottom:1px solid LightBlue;">
                                <th style="padding:5px; text-align:left;">Attachment</th>
                                <th style="padding:5px; width:180px; text-align:left;" >Timestamp</th>
                                <th style="padding:5px; width:80px;  text-align:right;">Size</th>
                                <th style="padding:5px; width:60px;  text-align:left; ">DDNA</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for='file in email.files' 
                                style='border-bottom:1px solid #eeeeee;'>
                                <td style="padding:5px; vertical-align:top; word-break:break-all; font-size:12px;">
                                    {{ file.name }}
                                </td>
                                <td style="padding:5px; vertical-align:top; white-space:nowrap; font-size:12px;">
                                    {{ file.date | moment("Do MMM YYYY, HH:mm:ss") }}
                                </td>
                                <td style="padding:5px; vertical-align:top; text-align:right; font-size:12px;">
                                    {{ file.size }}
                                </td>
                                <td style="padding:5px; vertical-align:top; font-family:monospace; white-space:nowrap; font-size:12px;">
                                    {{ file.ddna.substr(0, 3) }}-{{ file.ddna.substr(-3) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table  v-if="status!='loading'"  style="width:100%; margin-top:5px;">
                        <thead style="display: table-header-group;">
                            <tr style="page-break-inside:avoid; border-bottom:1px solid LightBlue;">
                                <th style="padding:5px; text-align:left;">Email Text</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style='border-top:1px solid lightgrey; border-bottom:1px solid lightgrey;' >
                                <td style='padding:5px; font-size:12px;'  v-html=email.body ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="modal-footer">
                    <button type="button" class="ml-auto btn btn-primary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Source_Email_viewer",
        props: [
            'file'
        ],
        components: {},

        computed: {},

        watch: {
            // Get Email details
            'file.id': function(id) {
                this.status = 'loading';
                this.get_source_email(this.file.email_id);
            },
        },

        created() {},
        mounted() {},

        data() {
            return {
                status:    'loading',
                email:     '',
				api_token: localStorage.getItem('api_token'),
            };
        },

        methods: {
            close() {
                this.$emit('close');
            },

            b64decode(str) {		
                return atob(str);
            },

            get_source_email: async function(id) {
                let _self = this;

                // Fetch
                if (id != null  &&  id != '') {
                    // Call API for files
                    const post_data = {
                        api_token:   this.api_token,
                        id:          id,
                    };

                    this.axios.post('api/emails', post_data)
                    .then(response => {
                        //console.log('email response =', response.data); 
                        _self.status = 'loaded';  
                        _self.email  = response.data.email;
                    })
                    .catch(function (error) {
                        //console.log('GET Error:', error);
                        _self.status = 'no data';  
                    });    
                }
            },  
        },
    };
</script>
<style>
</style>